import QRCode from 'react-qr-code'
import { useRecoilState, useSetRecoilState } from 'recoil'
import styled from 'styled-components'

import Close from '~/shared/assets/icons/Close'
import { isModalOpenState, qrModalValueState } from '~/shared/states'
import theme from '~/shared/styles/theme'

function QrModal() {
  const setIsModalOpen = useSetRecoilState(isModalOpenState)

  const [qrModalValue, setQrModalValue] = useRecoilState(qrModalValueState)

  return (
    <Wrapper onClick={(e) => e.stopPropagation()}>
      <CloseIcon
        onClick={() => {
          setQrModalValue({ ticketType: '', qrCode: '' })
          setIsModalOpen({ contents: '', isOpen: false })
        }}
      />
      <Title>
        QR을 스캔하여 <br /> 입장해 주세요.
      </Title>
      <TicketName>{qrModalValue.ticketType}</TicketName>
      <QRCode
        size={256}
        style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
        value={qrModalValue.qrCode}
        viewBox={`0 0 256 256`}
      />
    </Wrapper>
  )
}

export default QrModal

const Wrapper = styled.section`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  display: flex;
  flex-direction: column;
  gap: 36px;
  align-items: center;

  box-sizing: border-box;
  width: 500px;
  height: auto;
  max-height: 80vh;
  margin: 0 auto;
  padding: 108px 77px 60px;

  background-color: ${theme.colors.white};
  border-radius: 12px;

  @media ${theme.device.medium} {
    top: 0%;
    left: 0%;
    transform: translate(0, 0);

    box-sizing: border-box;
    width: 100vw;
    height: 100vh;
    max-height: 100vh;
    padding: 56px 20px 30px;

    border-radius: 0;
  }
`

const CloseIcon = styled(Close)`
  position: absolute;
  top: 36px;
  right: 36px;

  @media ${theme.device.medium} {
    top: 20px;
    right: 20px;
    width: 24px;
    height: 24px;
  }
`

const Title = styled.h1`
  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 42px;
  font-weight: 500;
  line-height: 60px;
  text-align: center;

  @media ${theme.device.medium} {
    font-size: 36px;
  }
`

const TicketName = styled.div`
  font-family: NanumSquareNeo-Regular, sans-serif;
`
